import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	height: 32px;
	display: flex;
	gap: 8px;
	align-items: center;
	justify-content: center;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 12px;
	padding: 4px;
	padding-left: 8px;
	padding-right: 12px;
	cursor: pointer;
	transition: background-color 0.2s ease-in-out;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
	}
`;

export const Icon = styled.div`
	pointer-events: none;
	top: -2px;
	right: -2px;
`;

export const ThumbnailImage = styled.img`
	width: 28px;
	height: 28px;
	object-fit: cover;
	border-radius: 6px;
	flex-shrink: 0;
`;

export const Loader = styled.div`
	pointer-events: none;
	top: -2px;
	right: -2px;
	margin-right: 2px;
`;

export const Text = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[700]};
	min-width: max-content;
	height: 28px;
	line-height: 14px;
`;

export const Filename = styled.div`
	font-size: 12px;
	font-weight: 600;
	max-width: 150px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const FileType = styled.div`
	font-size: 12px;
	font-weight: 300;
`;

export const DeleteIcon = styled.div`
	position: absolute;
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
	top: -2px;
	right: -2px;
	pointer-events: all;
`;
